module.exports = __webpack_public_path__ + "language-switcher-01ac634c/illustration-mobile-08e23e2c5fd2217de596b01de32f9372.svg";